import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Spin } from "antd";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  heading: string;
  paragraph?: string | JSX.Element;
}

const InfoBox = (props: PropsType) => {
  const { onClose, heading, paragraph } = props;

  const onCloseHandler = () => {
    onClose();
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={false}>
      <div className="modalWrapper ">
        <div className="modal_header">
          <div className="title">
            <h3> {heading} </h3>
          </div>
        </div>

        <div className="modal_content">
          <p style={{ color: "#151718" }}>{paragraph} </p>
        </div>

        <div className="modal_footer">
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={onCloseHandler}
          >
            Got it
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default InfoBox;
